import { PagingArgs } from "@/core/models/args/paging"

export class SpacesArgs extends PagingArgs {
  organizationId: string
}
